/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InstallLicenseEndpointRequest
 */
export interface InstallLicenseEndpointRequest {
    /**
     * 
     * @type {string}
     * @memberof InstallLicenseEndpointRequest
     */
    license: string;
    /**
     * 
     * @type {string}
     * @memberof InstallLicenseEndpointRequest
     */
    signature: string;
}

export function InstallLicenseEndpointRequestFromJSON(json: any): InstallLicenseEndpointRequest {
    return InstallLicenseEndpointRequestFromJSONTyped(json, false);
}

export function InstallLicenseEndpointRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): InstallLicenseEndpointRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'license': json['license'],
        'signature': json['signature'],
    };
}

export function InstallLicenseEndpointRequestToJSON(value?: InstallLicenseEndpointRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'license': value.license,
        'signature': value.signature,
    };
}


